import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import ServiceHighlights from '../components/ServiceHighlights';
import AboutSection from '../components/AboutSection';
import StatsCounter from '../components/StatsCounter';
import ComfortSection from '../components/ComfortSection';
import ServicesSection from '../components/ServicesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CaseStudiesSection from '../components/CaseStudiesSection';
import FAQSection from '../components/FAQSection';
import BlogSection from '../components/BlogSection';

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ServiceHighlights />
        <AboutSection />
        <StatsCounter />
        <ComfortSection />
        <ServicesSection />
        <TestimonialsSection />
        <CaseStudiesSection />
        <FAQSection />
        <BlogSection />
      </main>
      <Footer />
    </>
  );
}
